import React from 'react'

const PluxeeLogoUrl = "/meta/Pluxee_512.png"
const PluxeeLogo =  ({ width, height, className }) => (
	<div className={className}>
		<img src = {PluxeeLogoUrl} width={width} height={height} alt="Pluxee Logo" />
	</div>
)
export {PluxeeLogoUrl, PluxeeLogo}
	
